import React, { useState, useRef, useEffect } from "react";

const SelectInput = ({ name, label, options = [], value = [], onChange, icon }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValues, setSelectedValues] = useState(
        Array.isArray(value) ? value : value ? [value] : []
    );

    const toggleDropdown = () => setIsOpen(!isOpen);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleOptionClick = (val) => {
        let newSelected;
        if (selectedValues.includes(val)) {
            newSelected = selectedValues.filter((v) => v !== val);
        } else {
            newSelected = [...selectedValues, val];
        }
        setSelectedValues(newSelected);
        onChange && onChange(newSelected);

        window.scrollTo({
            top: wrapperRef.current.getBoundingClientRect().top + window.scrollY - 100,
            behavior: "smooth",
        });
    };

    return (
        <div className="select select-custom" ref={wrapperRef}>
            <select name={name} multiple hidden value={selectedValues} onChange={() => {}}>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>

            <div className="backdrop"></div>

            <button
                type="button"
                role="combobox"
                id="select"
                aria-controls="listbox"
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                tabIndex={0}
                onClick={toggleDropdown}
            >
                <span className="ellipse"></span>
                <span className="ellipse"></span>
                <span className="ellipse"></span>
                {icon}
                <span className="label">{label}</span>
                <span className="selected">
                    {options
                        .filter((opt) => selectedValues.includes(opt.value))
                        .map((opt) => (
                            <span key={opt.value} className="tag">
                                {opt.label}
                            </span>
                        ))}
                </span>
                <span className="icon-arrow-down">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        style={{ transform: isOpen ? "rotate(180deg)" : "" }}
                    >
                        <g style={{ mixBlendMode: "difference" }}>
                            <path
                                d="M12 6.5L8 10.5L4 6.5"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                    </svg>
                </span>
            </button>

            <div aria-live="assertive" role="alert" className="announcement"></div>

            <ul
                role="listbox"
                id="listbox"
                style={isOpen ? { opacity: 1, transform: "scale(1,1)", pointerEvents: "auto" } : {}}
            >
                {options.map((option) => {
                    const isSelected = selectedValues.includes(option.value);
                    return (
                        <li
                            key={option.value}
                            role="option"
                            data-value={option.value}
                            className={isSelected ? "active" : ""}
                            aria-selected={isSelected}
                            onClick={() => handleOptionClick(option.value)}
                        >
                            <span className="ellipse"></span>
                            <span className="ellipse"></span>
                            <span className="ellipse"></span>
                            <span className="label">{option.label}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SelectInput;
